module.exports = __webpack_public_path__ + "img/btn-border-white-hover.8991ad7.svg";